module.exports = __webpack_public_path__ + "static/media/class (3).05707c54.webp";